import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=5d966a74&scoped=true&"
var script = {}
import style0 from "./Carousel.vue?vue&type=style&index=0&id=5d966a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d966a74",
  null
  
)

export default component.exports